import { CurrencyEnum as PrismaCurrencyEnum } from "@prisma/client";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import React, { FC } from "react";

import { CurrencyEnum } from "@/generated/generated-hooks";

type PriceWithCurrencyProps = {
  currency: CurrencyEnum | PrismaCurrencyEnum;
  price: number;
  className?: string;
  bold?: boolean;
  light?: boolean;
};

export const PriceWithCurrency: FC<PriceWithCurrencyProps> = (props) => {
  const { currency, price, className, bold, light } = props;
  const { t } = useTranslation("common");

  return (
    <span
      className={clsx(className, bold && "font-bold", light && "font-light")}
    >
      {t(`common:currency.${currency?.toLowerCase() ?? "usd"}`)}
      &nbsp;
      {price}
    </span>
  );
};
